import { HorizontalLineSC as HorizontalLineAtom, Spacer } from '@dot/design-system';
import { Trans, useTranslation } from 'react-i18next';
import { default as styled } from 'styled-components';

import { Text } from '../../styles';

import { Loading } from './loading';

import { SecuredByBadge } from '@/components/SecuredByBadge/SecuredByBadge';
import { QRCode } from '@/components/qr-code';
import { ShortenedUrl } from '@/components/shortened-url';

const HorizontalLine = styled(HorizontalLineAtom)`
  background-color: ${(p) => p.theme.colors.oxfordBlue[30]};
  width: 19.5rem;
`;

const FlexSpacer = styled(Spacer)`
  display: flex;
  justify-content: center;
`;

const QrWrapper = styled.div`
  height: 8.25rem;
  width: 8.25rem;
`;

const InfoText = styled(Text)`
  strong {
    font-size: 1.1rem;
  }
`;

type Props = {
  isLoading: boolean;
  qrCode: string | null;
  shortUrl?: string;
};

export const Pending = ({ isLoading, qrCode, shortUrl }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Loading />
      <Spacer $top={0.5}>
        <InfoText>
          <Trans>{t('steps.mobileRedirect.pending.infoText')}</Trans>
        </InfoText>
      </Spacer>
      <FlexSpacer $bottom={1.625} $top={1.625}>
        <HorizontalLine />
      </FlexSpacer>
      <Text>
        <Trans>{t('steps.mobileRedirect.pending.helperText')}</Trans>
        <ShortenedUrl isLoading={isLoading} shortUrl={shortUrl} />
      </Text>
      <FlexSpacer $top={0.25}>
        <QrWrapper>
          <QRCode qrCode={qrCode} />
        </QrWrapper>
      </FlexSpacer>
      <Spacer $top={1}>
        <SecuredByBadge />
      </Spacer>
    </>
  );
};
